import { Container, Row, Col, Card } from 'react-bootstrap';

const PaymentCancelled = () => {
    return (
        <Container className="mt-4">
            <Row className="justify-content-center">
                <Col md={8} lg={6}>
                    <Card className="p-4">
                        <h2 className="mb-3">Payment cancelled</h2>
                        <p>
                            You cancelled the payment process. If this was a mistake,
                            you can try again from your dashboard.
                        </p>
                    </Card>
                </Col>
            </Row>
        </Container>
    );
};

export default PaymentCancelled;
